export default __webpack_public_path__ + "static/media/successor_approaching.dde9888f.svg";